import { render } from "./modalGeneric.vue?vue&type=template&id=363f4790&scoped=true"
import script from "./modalGeneric.vue?vue&type=script&lang=js"
export * from "./modalGeneric.vue?vue&type=script&lang=js"

import "./modalGeneric.vue?vue&type=style&index=0&id=363f4790&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363f4790"]])

export default __exports__